import React from 'react';
import GlobalWaitlistTable from '@/features/dashboard/waitlist/components/GlobalWaitlistTable.tsx';

const WaitlistPage = () => {
  return <GlobalWaitlistTable />;
};

export default WaitlistPage;
